import { serviceDeskLiveChatEntryPoint } from '@jira/spa-apps__project-settings-service-desk-live-chat/src/serviceDeskLiveChatEntryPoint.entrypoint.tsx';
import { projectSettingsServicedeskLiveChatRoute } from '@jira/router-routes__project-settings-service-desk-live-chat-routes/src/projectSettingsServicedeskLiveChatRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskLiveChat, {
	LazyProjectSettingsServiceDeskLiveChat,
} from './ui/service-desk-live-chat/index.tsx';

const projectSettingsServiceDeskLiveChatPageEntryPoint = createPageEntryPoint({
	main: serviceDeskLiveChatEntryPoint,
});

export const projectSettingsServicedeskLiveChatRouteEntry: Route = createEntry(
	projectSettingsServicedeskLiveChatRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskLiveChat,
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			servicedeskIssueTypesResource,
		],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskLiveChat],
		entryPoint() {
			return projectSettingsServiceDeskLiveChatPageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
